import styled from 'styled-components';

export const List = styled.ul`
padding: 0;
list-style: none;
display: flex;
flex-direction: column;
align-items: flex-start;
`;

export const Item = styled.li`
color: #000;
font-weight: 400;
font-size: 22px;
margin-bottom: 15px;
`;